import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams  } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import "../assets/css/Viewtest.css";
import Swal from "sweetalert2";
import BoxPay from "boxpay-sdk";
import { baseurl } from "../utility/helper";
import HiddenPayuForm from "../components/forms/HiddenPayuForm";

const InsViewTest = () => {
  const Candidateid = parseInt(sessionStorage.getItem("CandidateID")) || null;
  const [seatCount, setSeatCount] = useState(0);
  const [profileComplete, setProfileComplete] = useState(false);
  const [profileChecked, setProfileChecked] = useState(false);
  console.log(sessionStorage, seatCount);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const testId = 
    parseInt(searchParams.get("testId")) ||           // try URL param first
    (location.state && location.state.testId) ||      // fallback to state
    null;
  const studenttype =(searchParams.get("studenttype")) ||           // try URL param first
    (location.state && location.state.studenttype) ||      // fallback to state
    null;                                              // default to null
  const [testData, setTestData] = useState(null);
  const [lastTest, setlastTest] = useState(null);
  const [error, setError] = useState(null);
  const [fees, setFees] = useState(null);
  const [formData, setFormData] = useState({
    mobile: "",
    firstname: "",
    lastname: "",
    email: "",
    gender: "",
    dob: "",
    address: "",
    state: "",
    city: "",
    pincode: "",
    testId: testId,
  });
  const [formErrors, setFormErrors] = useState({});
  const Candidatedob = sessionStorage.getItem("Candidatedob") || null;

  const parseAgeGroup = (ageGroup) => {
    if (!ageGroup) return { min: -Infinity, max: Infinity };
    const [minStr, maxStr] = ageGroup.split('-').map(s => s.trim());
    const min = minStr ? parseFloat(minStr) : -Infinity;
    const max = maxStr ? parseFloat(maxStr) : Infinity;
    return { min, max };
  };

  const fetchlastTest = async () => {
    try {
      const id = parseInt(sessionStorage.getItem("CandidateID")) || null;
      const response = await axios.get(`${baseurl}/candidate/tests/${id}`);

      if (response.data && response.data.length > 0) {
        setlastTest(response.data[0]); // only first data
        
      } else {
        setlastTest(null); // or handle empty case
      }
    } catch (error) {
      console.error("Error fetching test data:", error);
    }
  };



  useEffect(() => {
    const fetchTestData = async () => {
      if (testId) {
        try {
          const response = await axios.get(
            `${baseurl}/tests/${testId}`
          );
          const data = response.data;

          const formattedData = {
            ...data,
            test_start_time: dayjs(
              data.test_start_time,
              "DD-MM-YYYY hh:mm A"
            ).format("YYYY-MM-DDTHH:mm"),
            test_end_time: dayjs(
              data.test_end_time,
              "DD-MM-YYYY hh:mm A"
            ).format("YYYY-MM-DDTHH:mm"),
            register_start_date: dayjs(
              data.register_start_date,
              "DD-MM-YYYY hh:mm A"
            ).format("YYYY-MM-DDTHH:mm"),
            register_end_date: dayjs(
              data.register_end_date,
              "DD-MM-YYYY hh:mm A"
            ).format("YYYY-MM-DDTHH:mm"),
          };

          setTestData(formattedData);
          // console.log('Test ID:', formattedData.test_id);
        } catch (error) {
          console.error("Error fetching test data:", error);
          setError("Failed to fetch test data. Please try again later.");
        }
      }
    };

    fetchTestData();
  }, [testId]);

  useEffect(() => {
    fetchFees();
    if (Candidateid) {        // only fetch if logged in
      fetchlastTest();
    }
    fetchRegisterSeat(testId);
  }, []);

  useEffect(() => {
  const checkProfile = async () => {
    try {
      const userId = sessionStorage.getItem("CandidateID");

      if (!userId) return;

      const response = await axios.get(
        `${baseurl}/candidate/check_profile/${userId}`
      );

      if (response.data.completed) {
        setProfileComplete(true);
      } else {
        setProfileComplete(false);

        const missing = response.data?.missingFields || [];

        Swal.fire({
          title: "Incomplete Profile",
          html: `
            <p>Please complete your profile before making a payment.</p>
            ${
              missing.length > 0
                ? `<div style="margin-top:10px; text-align:left;">
                    <strong>Missing fields:</strong>
                    <ul style="margin-top:6px; padding-left:20px; color:#ef4444;">
                      ${missing.map((f) => `<li>${f}</li>`).join("")}
                    </ul>
                  </div>`
                : ""
            }
          `,
          icon: "error",
          confirmButtonText: "Update Profile",
        }).then(() => {
          navigate("/Profile", { state: { type: "candidate", defaultTab: "#four"  } });
        });
      }

      setProfileChecked(true);
    } catch (error) {
      console.error("Profile check error:", error);
    }
  };

  checkProfile();
}, []);

  const fetchFees = async () => {
    try {
      const response = await axios.get(`${baseurl}/admin/getFees`);

      let feeRecord = null;

      if (studenttype === "institutestudent") {
        feeRecord = response.data.find(
          fee => fee.fee_id === 11 || fee.fee_id === "11"
        );
      } else if (studenttype === "instituteteacher") {
        feeRecord = response.data.find(
          fee => fee.fee_id === 12 || fee.fee_id === "12"
        );
      }

      if (feeRecord) {
        console.log("Fee Amount:", feeRecord.fees);
        setFees(feeRecord.fees);
      } else {
        console.warn("Fee record not found");
        setFees("");
      }
    } catch (error) {
      console.error("Error fetching fees:", error);
      alert("Failed to fetch fees.");
    }
  };

    // Function to fetch seat registration count
  const fetchRegisterSeat = async (testId) => {
    try {
      const response = await fetch(`${baseurl}/admin/registered-seats/${testId}`);
      const data = await response.json();
      setSeatCount(data.count); // data: { count: 5 }
      console.log("seat count:", data.count);
    } catch (error) {
      console.error('Error fetching registered seats:', error);
    }
  };


  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const validateForm = () => {
    const errors = {};
    const {
      mobile,
      firstname,
      lastname,
      email,
      gender,
      dob,
      address,
      state,
      city,
      pincode,
    } = formData;

    if (!mobile.match(/^\d{10}$/)) {
      errors.mobile = "Mobile number must be 10 digits.";
    }
    if (!firstname) {
      errors.firstname = "First name is required.";
    }
    if (!lastname) {
      errors.lastname = "Last name is required.";
    }
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      errors.email = "Email is invalid.";
    }
    if (!gender) {
      errors.gender = "gender is required.";
    }
    if (!dob) {
      errors.dob = "Date of Birth is required.";
    }
    if (!address) {
      errors.address = "Address is required.";
    }
    if (!state) {
      errors.state = "State is required.";
    }
    if (!city) {
      errors.city = "City is required.";
    }

    return errors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    try {
      const response = await axios.post(`${baseurl}/testcandidate`, {
        mobile: formData.mobile,
        firstname: formData.firstname,
        lastname: formData.lastname,
        email: formData.email,
        gender: formData.gender,
        dob: formData.dob,
        address: formData.address,
        state: formData.state,
        city: formData.city,
        pincode: formData.pincode,
        testId: testId,
        test_title: testData.test_title,
        chapter: testData.chapter_id,
      });
      // Show success message using SweetAlert
      Swal.fire({
        title: "Success!",
        text: "Form Submitted successfully! Plz login and Make Payment",
        icon: "success",
        confirmButtonText: "OK",
      });

      // Optionally, reset the form or redirect the user
      setFormData({
        mobile: "",
        firstname: "",
        lastname: "",
        email: "",
        gender: "",
        dob: "",
        address: "",
        state: "",
        city: "",
        pincode: "",
      });
      setFormErrors({});
    } catch (error) {
      console.error("Error registering Test:", error);

      // Check if the error response indicates that the candidate is already registered
      if (error.response && error.response.status === 409) {
        Swal.fire({
          title: "Already Registered!",
          text: "You are already registered as a candidate. Please login.",
          icon: "info",
          confirmButtonText: "Candidate Login",
        }).then((result) => {
          if (result.isConfirmed) {
            // Navigate to the /Candidatelogin page
            // window.location.href = '/Candidatelogin'; // Use this for a full page reload
            // Alternatively, if you are using React Router, you can use:
            navigate("/Candidatelogin");
          }
        });
      } else if (error.response && error.response.status === 403) {
        // Check if the error response indicates that the user is already a member
        Swal.fire({
          title: "Membership Alert!",
          text: "You are already a member, You Cannot Register For The Test.",
          icon: "info",
          confirmButtonText: "OK",
        });
      } else {
        // Handle other error responses
        Swal.fire({
          title: "Error!",
          text: "There was an error registering the test. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
    errors.pincode = "";
    // Handle form submission logic here
  };

  if (error) {
    return <div>{error}</div>;
  }

  if (!testData) {
    return <div>Loading...</div>;
  }



  const parsedstartDate = dayjs(testData.test_start_time, "DD-MM-YYYY hh:mm A");
  const parsedendDate = dayjs(testData.test_end_time, "DD-MM-YYYY hh:mm A");
  const startTime = parsedstartDate.format("hh:mm A");
  const endTime = parsedendDate.format("hh:mm A");
  function formatDateWithSuffix(dateStr) {
    const date = new Date(dateStr);
    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    const weekday = date.toLocaleString("default", { weekday: "long" });
    const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;

    return `${weekday}, ${dayWithSuffix} ${month}, ${year}`;
  }

  const getAgeInYears = (dobISO) => {
    if (!dobISO) return null;
    const dob = new Date(dobISO);
    if (isNaN(dob)) return null;
    const now = new Date();
    const ms = now - dob;
    const years = ms / (1000 * 60 * 60 * 24 * 365.2425);
    return years;
  };

  let isEligible = null;
  let age = null;
  let min = null;
  let max = null;
  if (Candidateid) {   // only calculate when Candidateid exists
    age = getAgeInYears(Candidatedob);
    const ageRange = parseAgeGroup(testData.age_group);
    min = ageRange.min;
    max = ageRange.max;
    isEligible = age !== null ? (age >= min && age <= max) : null;
  }

  const formatAgeRange = (range) => {
    const [min, max] = range.split("-").map(Number);

    const format = (age) => {
      const years = Math.floor(age);
      const months = Math.round((age - years) * 12);
      if (months > 0) return `${years} years ${months} months`;
      return `${years} years`;
    };

    return `${format(min)} - ${format(max)}`;
  };
  
  let payuTestId = "";

  if (studenttype === "institutestudent") {
    payuTestId = `InstStuTest-${testId}`;
  } else if (studenttype === "instituteteacher") {
    payuTestId = `InstTeaStuTest-${testId}`;
  }

  return (
    <div>
      <div className="event" style={{ marginTop: "100px" }}>
        <div className="container" style={{ paddingTop: "30px" }}>
          <div className="row">
            <div className="testregisters col-lg-8">
              <h1
                style={{ fontSize: "30px", fontWeight: "bold", color: "grey" }}
              >
                test@{testData.test_title}
              </h1>
              <br />
              <p>Next Test Date:</p>
              <p style={{ color: "red", fontWeight: "500" }}>
                {formatDateWithSuffix(testData.test_start_time)}
              </p>
              <p style={{ color: "blue", fontWeight: "400" }}>
                for Candidates aged {formatAgeRange(testData.age_group)}
              </p>
              <p>
                Time: {startTime} to {endTime} ({testData.note})
              </p>
              <p>
                Testing Fees: &nbsp;
                <span style={{ color: "blue", fontWeight: "400" }}>
                  Rs. {testData.approved_fee_snapshot ?? fees}/-
                </span>{" "}
                payable online at the time of registration
              </p>
              <p>
                Venue:{" "}
                <span style={{ color: "blue", fontWeight: "400" }}>
                  {testData.venue}
                </span>
              </p>
              <p style={{ fontWeight: "bold" }}>
                No further confirmation is necessary after payment is made
              </p>
              <p style={{ color: "grey" }}>
                If the test is cancelled due to any reason, registrants shall be
                informed by e-mail/sms/phone about cancellation and new date of
                test.
              </p>
              {Candidateid !== null && (
                <>
                {isEligible === null ? (
                    <div style={{ color: "red", fontWeight: "bold" }}>
                      
                    </div>
                  ) : !isEligible ? (
                    <div style={{ color: 'red', fontWeight: 'bold' }}>
                      Not eligible for this test. Allowed age: {min}-{max} years. Your age: {age.toFixed(1)} years.
                    </div>
                  ) : (
                    Candidateid !== null ? (
                      <div className="row" style={{ marginBottom: "10px" }}>
                        {/* <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={SubmitPayment}
                          style={{ marginTop: "20px", backgroundColor: "#000C80" }}
                        >
                          Make Payment
                        </button> */}
                        {seatCount >= testData.seat ? (
                          <div style={{ color: "red", fontWeight: "bold" }}>
                            Seat Not Available
                          </div>
                        ) : lastTest ? (
                          (() => {
                            const lastTestDate = new Date(lastTest.test_start_time); // adjust field name
                            const now = new Date();

                            // difference in years
                            const diffYears =
                              (now.getTime() - lastTestDate.getTime()) / (1000 * 60 * 60 * 24 * 365);

                            if (diffYears >= 1) {
                              if (!profileChecked) {
                                return <div>Checking profile...</div>;
                              }

                              if (!profileComplete) {
                                return (
                                  <div style={{ color: "red", fontWeight: "bold" }}>
                                    Please complete your profile to proceed with payment
                                  </div>
                                );
                              }
                              
                              return <HiddenPayuForm testId={payuTestId} />;
                            } else {
                              return (
                                <div style={{ color: "red", fontWeight: "bold" }}>
                                  Your last test is not 1 year old
                                </div>
                              );
                            }
                          })()
                        ) : (
                           // if no last test exists → allow form (ONLY if profile complete)
                            profileChecked ? (
                              profileComplete ? (
                                <HiddenPayuForm testId={payuTestId} />
                              ) : (
                                <div style={{ color: "red", fontWeight: "bold" }}>
                                  Please complete your profile to proceed with payment
                                </div>
                              )
                            ) : (
                              <div>Checking profile...</div>
                            )
                        )}
                      </div>
                    ):(
                      ""
                    )
                  )
                }
                </>
              )}
              <br></br>
            </div>
            {Candidateid === null ? (
              <div
                className="col-lg-4"
              >
                              <div style={{ padding: "15px", textAlign: "center" }}>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => navigate("/Candidatelogin", { state: { fromPage: "ViewTest", testId: testId } })}
                                >
                                  Apply Now
                                </button>
                              </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <br />
        </div>
      </div>
    </div>
  );
};

export default InsViewTest;
